import { uniqueId } from 'lodash';

const defaultOptions = {
  color: 'warning'
};

const createToast = options => ({
  ...defaultOptions,
  ...options,
  id: uniqueId()
});

export default createToast;
